jQuery(document).ready(function($) {
  //how it works accordion single open
  jQuery('.how-it-works-wrapper .accordion').click(function(e) {
	e.preventDefault();
	var currentIsActive = jQuery(this).hasClass('active');
	jQuery(this).parent('.accordion-wrapper').find('> *').removeClass('active');
	if(currentIsActive != 1) {
		jQuery(this).addClass('active');
		jQuery(this).next('.panel').addClass('active');
	}
  });

  /*let url = window.location.href;
  if (url.includes('/collections/socks')) {
      location.href = '/pages/socks';
  }*/
           
  //master your movement accordion single open
  jQuery('.master-your-movement-wrapper .accordion').click(function(e) {
	e.preventDefault();
	var currentIsActive = jQuery(this).hasClass('active');
	jQuery(this).parent('.accordion-wrapper').find('> *').removeClass('active');
	if(currentIsActive != 1) {
		jQuery(this).addClass('active');
		jQuery(this).next('.panel').addClass('active');
	}
  });

  setTimeout(function(){
    //Globo Menu load for mobile
    jQuery('li.gm-has-submenu a .gm-text:contains("-Mobile")').closest('li').addClass('hideDesktop');
    jQuery("li.gm-has-submenu a .gm-text").text(function () {
        return $(this).text().replace("-Mobile", ""); 
    });
    jQuery("li.gm-has-submenu").filter(function() {
        return $('i', this).hasClass('gm-icon');
    }).addClass('hideDesktop');

    //PDP Scrolling SVG
    jQuery('#shopify-section-template--14696795799621__6d1a0b9b-8aef-4122-8ef7-0108798f2869').clone().appendTo('.pdp_scrolling_svg');
    jQuery('#shopify-section-template--14696795799621__6d1a0b9b-8aef-4122-8ef7-0108798f2869').remove();

    //Kinesis PDP Scrolling SVG
    jQuery('#shopify-section-template--14696795832389__ab8a92aa-912c-4f38-a3ce-9a6548aae97c').clone().appendTo('.pdp_scrolling_svg');
    jQuery('#shopify-section-template--14696795832389__ab8a92aa-912c-4f38-a3ce-9a6548aae97c').remove();
    
  },1000);

  //Size chart popup - PDP
  $("#sizechartbtn").click(function(){
    jQuery('.sizechart_block').show();
    jQuery('.sizechart_block').addClass("open");
  });
  
  $("#sizechartbtn_close").click(function(){
      jQuery('.sizechart_block').hide();
      jQuery('.sizechart_block').removeClass("open");
  });

  // jQuery('.variant-input label').click(function(){
  //     window.location.replace(window.location.href);
  // });

  //Homepage Testimonials - read more & read less functionality
  jQuery('.review_readmore_btn').click(function(e) {
      jQuery(this).closest('.testimonials-slider__text').find("p.hideReview").css("display", "block");
      jQuery(this).closest('.testimonials-slider__text').find("span.hideReview").css("display", "block");
      jQuery(this).closest('.testimonials-slider__text').find(".review_readless_btn").css("display", "block");
      jQuery(this).closest('.testimonials-slider__text').find(".review_readmore_btn").css("display", "none");
      jQuery('.testimonials-slider .flickity-viewport').attr('style', 'height: 600px !important');
  });
  jQuery('.review_readless_btn').click(function(e) {
      jQuery(this).closest('.testimonials-slider__text').find("p.hideReview").css("display", "none");
      jQuery(this).closest('.testimonials-slider__text').find("span.hideReview").css("display", "none");
      jQuery(this).closest('.testimonials-slider__text').find(".review_readless_btn").css("display", "none");
      jQuery(this).closest('.testimonials-slider__text').find(".review_readmore_btn").css("display", "block");
      jQuery('.testimonials-slider .flickity-viewport').attr('style', 'height: 300px !important');
  });
  
});

//Sticky Add to Cart
$(document).scroll(function() {
    var y = $(this).scrollTop();
    if($(window).width() < 767)
    {
        if (y > 1200) {
            $('.sticky_addtocart_block').show(); 
        } else {
            $('.sticky_addtocart_block').hide();
        }
    } else {
        if (y > 800) {
            $('.sticky_addtocart_block').show();
        } else {
            $('.sticky_addtocart_block').hide();
        }
    }
});